export default __webpack_public_path__ + "static/media/lock-404.cb0de3e6.svg";